import $ from 'jquery';

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})